import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

function Join() {
  return (
    <div className="min-h-screen bg-black">
      <header className="fixed w-full bg-black/80 backdrop-blur-md z-50">
        <nav className="container mx-auto px-6 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <Zap className="h-8 w-8 text-blue-500" />
            <span className="text-xl font-bold text-white">Zimerson</span>
          </Link>
        </nav>
      </header>

      <div className="container mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl font-bold text-white mb-4">Influencer Network</h1>
          <p className="text-xl text-gray-300 mb-12">Apply to join the Zimerson Network for PAID marketing campaigns!</p>

          <form 
            action="https://api.web3forms.com/submit"
            method="POST"
            className="space-y-8"
          >
            <input type="hidden" name="access_key" value="94946f6f-3d9c-492c-bdeb-ea0b3b02e064" />
            <input type="hidden" name="subject" value="New Influencer Application" />
            <input type="hidden" name="from_name" value="Zimerson Website" />
            <input type="hidden" name="redirect" value="/success" />

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-300 mb-2">First Name *</label>
                <input
                  type="text"
                  name="firstName"
                  required
                  className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2">Last Name *</label>
                <input
                  type="text"
                  name="lastName"
                  required
                  className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Email *</label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Influencer Username *</label>
              <input
                type="text"
                name="username"
                required
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Main Social Platform *</label>
              <select
                name="platform"
                required
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              >
                <option value="">Select an option</option>
                <option value="instagram">Instagram</option>
                <option value="tiktok">TikTok</option>
                <option value="youtube">YouTube</option>
                <option value="twitter">Twitter</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Following Size *</label>
              <select
                name="followingSize"
                required
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              >
                <option value="">Select an option</option>
                <option value="10k-50k">10,000 - 50,000</option>
                <option value="50k-100k">50,000 - 100,000</option>
                <option value="100k-500k">100,000 - 500,000</option>
                <option value="500k-1m">500,000 - 1,000,000</option>
                <option value="1m+">1,000,000+</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Country *</label>
              <input
                type="text"
                name="country"
                required
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Mobile Number</label>
              <input
                type="tel"
                name="mobile"
                className="w-full px-4 py-3 rounded-lg newsletter-input text-white"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Are you currently managed? *</label>
              <div className="space-y-2">
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="isManaged"
                    value="yes"
                    required
                    className="text-blue-500"
                  />
                  <span className="text-gray-300">Yes</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="isManaged"
                    value="no"
                    required
                    className="text-blue-500"
                  />
                  <span className="text-gray-300">No</span>
                </label>
              </div>
            </div>

            <div>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="considerManagement"
                  className="text-blue-500"
                />
                <span className="text-gray-300">Consider me for Talent Management</span>
              </label>
            </div>

            <div>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="contactConsent"
                  className="text-blue-500"
                />
                <span className="text-gray-300">Contact Me (as per Privacy Policy)</span>
              </label>
            </div>

            <div>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="dataConsent"
                  required
                  className="text-blue-500"
                />
                <span className="text-gray-300">I accept that Zimerson will use my data *</span>
              </label>
            </div>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white px-6 py-4 rounded-lg text-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-colors"
            >
              Send Application
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export default Join;